export default function getLastNumberOfPhone(phone: string): number | undefined {
    if (! phone || ! phone.length) {
        return undefined
    }

    const lastChar = phone.substr(phone.length - 1, 1)
    return parseInt(lastChar, 10) || undefined
}
